import type { ClassOfferingDetail, GradebookFromQuery } from './classDetailTypes';

type Assignment = NonNullable<ClassOfferingDetail['assignments']>[number];
type RosterEntry = NonNullable<ClassOfferingDetail['rosterEntries']>[number];
type Student = RosterEntry['person'];

export function eligibleStudentsForAssignment(
  assignment: Assignment,
  gradebooks: ReadonlyArray<GradebookFromQuery>
): Student[] {
  const targetGradebookIds = new Set((assignment.targets ?? []).map((target) => target.gradebook.id));
  const students = new Map<string, Student>();

  gradebooks.forEach((gradebook) => {
    if (!targetGradebookIds.has(gradebook.id)) return;

    // The GraphQL memberships field is current-membership scoped. Retain the
    // ACTIVE check as a client-side guard against stale cached roster data.
    (gradebook.memberships ?? []).forEach((membership) => {
      if (membership.rosterEntry.state !== 'ACTIVE') return;
      students.set(membership.rosterEntry.person.id, membership.rosterEntry.person);
    });
  });

  return [...students.values()];
}
